import { render, staticRenderFns } from "./ChannelCreationCmp.vue?vue&type=template&id=32468d66&scoped=true&"
import script from "./ChannelCreationCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelCreationCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCreationCmp.vue?vue&type=style&index=0&id=32468d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32468d66",
  null
  
)

export default component.exports